import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b27f2f66"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "wrapper"
}
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "item" }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { class: "d-flex mt-auto ms-auto" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-file fas" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_ctx.samplingPoint)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_row, { gutter: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { lg: 24 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("subtitle.resume")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, { gutter: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { lg: 24 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_el_table, {
                    data: _ctx.dataValidation.data,
                    class: "result-table",
                    height: "460",
                    stripe: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        prop: "dateTime",
                        label: _ctx.$t('label.date'),
                        width: "180"
                      }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(_ctx.dateFormatDate(scope.row.dateTime)), 1)
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_table_column, {
                        prop: "estimation",
                        label: _ctx.$t('label.ourEstimations'),
                        width: "280"
                      }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(scope.row.estimation !== undefined ? scope.row.estimation : "-"), 1)
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_table_column, {
                        prop: "dataUpload",
                        label: _ctx.$t('label.uploadedData'),
                        width: "280"
                      }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(scope.row.dataUpload !== undefined ? scope.row.dataUpload : "-"), 1)
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_table_column, {
                        prop: "difference",
                        label: _ctx.$t('label.difference'),
                        width: "280"
                      }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(scope.row.difference !== undefined ? scope.row.difference : "-"), 1)
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_table_column, {
                        prop: "zScore",
                        label: "Z-SCORE",
                        width: "280"
                      }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(scope.row.zScore !== undefined ? scope.row.zScore : "-"), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"]),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_pagination, {
                        class: "app-table",
                        layout: "total, sizes, prev, pager, next, jumper",
                        currentPage: _ctx.currentPage,
                        "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPage) = $event)),
                        "page-sizes": [10],
                        "page-size": _ctx.rowPerPage,
                        total: _ctx.totalRows,
                        onSizeChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePaginationSize($event))),
                        onCurrentChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changePaginationPage($event)))
                      }, null, 8, ["currentPage", "page-size", "total"])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_el_tooltip, {
                        class: "box-item",
                        effect: "dark",
                        content: "Exportar excel y resultado",
                        placement: "bottom-end"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "default",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.downloadCSV()))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_6
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}